import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import MyPreset from '../assets/preset';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {MessageService} from 'primeng/api';
import {provideHttpClient, withInterceptors, withXsrfConfiguration} from '@angular/common/http';
import {xsrfInterceptor} from './interceptors/xsrf-interceptor';
import ptBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import {authInterceptor} from './interceptors/auth-interceptor';
import { provideLottieOptions } from 'ngx-lottie';
import { AuthService } from './services/auth.service';

registerLocaleData(ptBr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => inject(AuthService).csrf()),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-theme',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng'
          }
        }
      }
    }),
    provideHttpClient(
      withInterceptors([
        (req, next) => xsrfInterceptor(req, next),
        (req, next) => authInterceptor(req, next)
      ]),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN'
      })
    ),
    provideLottieOptions({ player: () => import('lottie-web') }),
    MessageService,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' }
  ]
};

